import React from "react";
import { Link } from "react-router-dom";

import useLoginSubmit from "../../hooks/useLoginSubmit";
import Error from "../Input/Error";

function SignIn({ clientLogin }) {

    const { onSubmit, register, handleSubmit, errors, otpVerification, setotpVerification, resendOTP } = useLoginSubmit();

    return (
        <div className="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
            <div className="w-100 p-3 p-md-5 card border-0 bg-dark text-light" style={{ maxWidth: "32rem" }}>
                <form className="row g-1 p-3 p-md-4" onSubmit={handleSubmit(onSubmit)}>
                    {clientLogin ? <div className="col-12 text-center mb-1 mb-lg-5">
                        <h1>Client Login</h1>
                    </div>
                        :
                        <div className="col-12 text-center mb-1 mb-lg-5">
                            <h1>Sign in</h1>
                            <span>Free access to our dashboard.</span>
                        </div>}
                    {otpVerification !== "gototp" ?
                        <>
                            <div className="col-12">
                                <div className="mb-2">
                                    <label className="form-label">Email address</label>
                                    <input
                                        {...register(`email`, { required: `Email is required!` })}
                                        name="email"
                                        type= {clientLogin ? "text" : "email"}
                                        className="form-control form-control-lg"
                                        placeholder="name@example.com" />
                                    <Error errorName={errors.email} />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="mb-2">
                                    <div className="form-label">
                                        <span className="d-flex justify-content-between align-items-center">
                                            Password
                                            <Link className="text-secondary" to="password-reset">Forgot Password?</Link>
                                        </span>
                                    </div>
                                    <input
                                        {...register(`password`, { required: `Password is required!` })}
                                        name="password"
                                        type="password"
                                        className="form-control form-control-lg"
                                        placeholder="***************" />
                                    <Error errorName={errors.password} />
                                </div>
                            </div>
                            <div className="col-12 text-center mt-4">
                                <button type="submit" className="btn btn-lg btn-block btn-light lift text-uppercase">SIGN IN</button>
                            </div>
                        </> :
                        <div className="col-12">
                            <div className="mb-2">
                                <label className="form-label">Enter OTP</label>
                                <input
                                    {...register(`otp`, { required: `OTP is required!` })}
                                    name="otp"
                                    type="text"
                                    className="form-control form-control-lg"
                                    onWheel={(e) => e.target.blur()} // Prevent mouse wheel
                                    placeholder="OTP" />
                                <Error errorName={errors.otp} />
                                <div className="form-label pt-2" >
                                    <span className="d-flex justify-content-between align-items-center text-success cursor-pointer" onClick={resendOTP}>
                                        <b> Resend Otp</b>
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 text-center mt-4">
                                    <span type="" className="btn btn-lg btn-block btn-light lift text-uppercase" onClick={() => setotpVerification("start")}>Back</span>
                                </div>
                                <div className="col-6 text-center mt-4">
                                    <button type="submit" className="btn btn-lg btn-block btn-light lift text-uppercase">SIGN IN</button>
                                </div>
                            </div>
                        </div>
                    }
                    {/* <div className="col-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" for="flexCheckDefault">
                                    Remember me
                                </label>
                            </div>
                        </div> */}
                </form>
            </div>
        </div>
    )

}

export default SignIn;